import { defineMessages } from "@formatjs/intl";

export default defineMessages({
  RoomName: {
    id: "InitialCost.RoomName",
    defaultMessage: `ビレッジハウス{name}`,
  },
  RoomNumber: {
    id: "InitialCost.RoomNumber",
    defaultMessage: `{bNo}号棟{rNo}号室`,
  },
  PDFFileName: {
    id: "InitialCost.PDFFileName",
    defaultMessage: `初期費用概算お見積書`,
  },
  PDFMoveInDate: {
    id: "InitialCost.PDFMoveInDate",
    defaultMessage: `{date} 入居の場合`,
  },
});
